import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import {DEFAULT_TIME_RANGE_OPTIONS} from '@shared/constants/timeRangeOptions'
import type {TimeRangeInterface} from '@shared/interfaces/timerange'

type InitStateProp = {
  relativeMode: boolean
  startDate: string
  endDate: string
  timeSelector: TimeRangeInterface
  resetZoom: boolean
}

const start = new Date()
const startDate = start.toISOString()

const initialState: InitStateProp = {
  relativeMode: false,
  startDate,
  endDate: startDate,
  timeSelector:
    DEFAULT_TIME_RANGE_OPTIONS.find((option) => option.value === '1 00:00:00') ||
    DEFAULT_TIME_RANGE_OPTIONS[0],
  resetZoom: false,
}

export const timeseries = createSlice({
  name: 'timeseries',
  initialState,
  reducers: {
    setBatchesStartDate: (state, action: PayloadAction<string>) => ({
      ...state,
      startDate: action.payload,
    }),
    setBatchesEndDate: (state, action: PayloadAction<string>) => ({
      ...state,
      endDate: action.payload,
    }),
    setRelativeMode: (state, action: PayloadAction<boolean>) => ({
      ...state,
      relativeMode: action.payload,
    }),
    setTimeSelector: (state, action: PayloadAction<TimeRangeInterface>) => ({
      ...state,
      timeSelector: action.payload,
    }),
    setResetZoom: (state, action: PayloadAction<boolean>) => ({
      ...state,
      resetZoom: action.payload,
    }),
  },
})

// Action creators are generated for each case reducer function
export const {
  setBatchesStartDate,
  setBatchesEndDate,
  setRelativeMode,
  setTimeSelector,
  setResetZoom,
} = timeseries.actions
export default timeseries.reducer
